import { BlankText } from './BlankText';

/**
 * If value is falsy, render BlankText, otherwise render children
 */
export function BlankTextOrContent({
  value,
  children,
}: {
  value: unknown;
  children?: React.ReactNode;
}) {
  if (value) {
    return children;
  }
  return <BlankText />;
}
